import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-option-buttons-wrapper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './main-option-buttons-wrapper.component.html',
  styleUrl: './main-option-buttons-wrapper.component.scss',
})
export class MainOptionButtonsWrapperComponent {}
